// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`render 1`] = `
Object {
  "asFragment": [Function],
  "baseElement": <body>
    <div>
      <div
        class="MuiContainer-root makeStyles-containerPadding-5 MuiContainer-maxWidthSm"
      >
        <div
          class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3"
        >
          <div
            class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          >
            <h3
              class="MuiTypography-root MuiTypography-h3"
            >
              Please check your email
            </h3>
          </div>
          <div
            class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          >
            <span
              class="MuiTypography-root makeStyles-body1-2 MuiTypography-body1"
            >
              <div
                class="MuiBox-root MuiBox-root-6"
              >
                Enter the verification code we sent to 
              </div>
              <div
                class="MuiBox-root MuiBox-root-7"
              >
                foo@bar.com
              </div>
              <div
                class="MuiBox-root MuiBox-root-8"
              >
                 to confirm this email belongs to you.
              </div>
            </span>
          </div>
          <div
            class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          >
            <div
              class="MuiFormControl-root MuiTextField-root makeStyles-root-1 MuiFormControl-fullWidth"
            >
              <label
                class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
                data-shrink="false"
                for="verification-code"
                id="verification-code-label"
              >
                Verification code
                <span
                  aria-hidden="true"
                  class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                >
                   
                  *
                </span>
              </label>
              <div
                class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
              >
                <input
                  aria-invalid="false"
                  class="MuiInputBase-input MuiOutlinedInput-input"
                  id="verification-code"
                  maxlength="6"
                  required=""
                  type="text"
                  value=""
                />
                <fieldset
                  aria-hidden="true"
                  class="PrivateNotchedOutline-root-9 MuiOutlinedInput-notchedOutline"
                >
                  <legend
                    class="PrivateNotchedOutline-legendLabelled-11"
                  >
                    <span>
                      Verification code
                       *
                    </span>
                  </legend>
                </fieldset>
              </div>
              
            </div>
          </div>
          <div
            class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-2 MuiGrid-item MuiGrid-align-items-xs-center MuiGrid-justify-xs-flex-end"
          >
            <div
              class="MuiBox-root MuiBox-root-13 MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-auto"
              style="padding: 0px;"
            >
              <div
                class="makeStyles-wrapper-3"
              >
                <button
                  class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary Mui-disabled MuiButton-fullWidth Mui-disabled"
                  data-testid="continueButton"
                  disabled=""
                  tabindex="-1"
                  type="button"
                >
                  <span
                    class="MuiButton-label"
                  >
                    CONTINUE
                  </span>
                </button>
              </div>
            </div>
            <div
              class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-auto"
              style="padding: 0px;"
            >
              <div
                class="makeStyles-wrapper-3"
              >
                <button
                  class="MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-fullWidth"
                  tabindex="0"
                  type="button"
                >
                  <span
                    class="MuiButton-label"
                  >
                    RESEND CODE
                  </span>
                  <span
                    class="MuiTouchRipple-root"
                  />
                </button>
              </div>
            </div>
            <div
              class="MuiBox-root MuiBox-root-14 MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-auto"
              style="padding: 0px;"
            >
              <div
                class="makeStyles-wrapper-3"
              >
                <button
                  class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary Mui-disabled MuiButton-fullWidth Mui-disabled"
                  disabled=""
                  tabindex="-1"
                  type="button"
                >
                  <span
                    class="MuiButton-label"
                  >
                    SUBMIT
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>,
  "container": <div>
    <div
      class="MuiContainer-root makeStyles-containerPadding-5 MuiContainer-maxWidthSm"
    >
      <div
        class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3"
      >
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
        >
          <h3
            class="MuiTypography-root MuiTypography-h3"
          >
            Please check your email
          </h3>
        </div>
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
        >
          <span
            class="MuiTypography-root makeStyles-body1-2 MuiTypography-body1"
          >
            <div
              class="MuiBox-root MuiBox-root-6"
            >
              Enter the verification code we sent to 
            </div>
            <div
              class="MuiBox-root MuiBox-root-7"
            >
              foo@bar.com
            </div>
            <div
              class="MuiBox-root MuiBox-root-8"
            >
               to confirm this email belongs to you.
            </div>
          </span>
        </div>
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
        >
          <div
            class="MuiFormControl-root MuiTextField-root makeStyles-root-1 MuiFormControl-fullWidth"
          >
            <label
              class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
              data-shrink="false"
              for="verification-code"
              id="verification-code-label"
            >
              Verification code
              <span
                aria-hidden="true"
                class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
              >
                 
                *
              </span>
            </label>
            <div
              class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
            >
              <input
                aria-invalid="false"
                class="MuiInputBase-input MuiOutlinedInput-input"
                id="verification-code"
                maxlength="6"
                required=""
                type="text"
                value=""
              />
              <fieldset
                aria-hidden="true"
                class="PrivateNotchedOutline-root-9 MuiOutlinedInput-notchedOutline"
              >
                <legend
                  class="PrivateNotchedOutline-legendLabelled-11"
                >
                  <span>
                    Verification code
                     *
                  </span>
                </legend>
              </fieldset>
            </div>
            
          </div>
        </div>
        <div
          class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-2 MuiGrid-item MuiGrid-align-items-xs-center MuiGrid-justify-xs-flex-end"
        >
          <div
            class="MuiBox-root MuiBox-root-13 MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-auto"
            style="padding: 0px;"
          >
            <div
              class="makeStyles-wrapper-3"
            >
              <button
                class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary Mui-disabled MuiButton-fullWidth Mui-disabled"
                data-testid="continueButton"
                disabled=""
                tabindex="-1"
                type="button"
              >
                <span
                  class="MuiButton-label"
                >
                  CONTINUE
                </span>
              </button>
            </div>
          </div>
          <div
            class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-auto"
            style="padding: 0px;"
          >
            <div
              class="makeStyles-wrapper-3"
            >
              <button
                class="MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-fullWidth"
                tabindex="0"
                type="button"
              >
                <span
                  class="MuiButton-label"
                >
                  RESEND CODE
                </span>
                <span
                  class="MuiTouchRipple-root"
                />
              </button>
            </div>
          </div>
          <div
            class="MuiBox-root MuiBox-root-14 MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-auto"
            style="padding: 0px;"
          >
            <div
              class="makeStyles-wrapper-3"
            >
              <button
                class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary Mui-disabled MuiButton-fullWidth Mui-disabled"
                disabled=""
                tabindex="-1"
                type="button"
              >
                <span
                  class="MuiButton-label"
                >
                  SUBMIT
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>,
  "debug": [Function],
  "findAllByAltText": [Function],
  "findAllByDisplayValue": [Function],
  "findAllByLabelText": [Function],
  "findAllByPlaceholderText": [Function],
  "findAllByRole": [Function],
  "findAllByTestId": [Function],
  "findAllByText": [Function],
  "findAllByTitle": [Function],
  "findByAltText": [Function],
  "findByDisplayValue": [Function],
  "findByLabelText": [Function],
  "findByPlaceholderText": [Function],
  "findByRole": [Function],
  "findByTestId": [Function],
  "findByText": [Function],
  "findByTitle": [Function],
  "getAllByAltText": [Function],
  "getAllByDisplayValue": [Function],
  "getAllByLabelText": [Function],
  "getAllByPlaceholderText": [Function],
  "getAllByRole": [Function],
  "getAllByTestId": [Function],
  "getAllByText": [Function],
  "getAllByTitle": [Function],
  "getByAltText": [Function],
  "getByDisplayValue": [Function],
  "getByLabelText": [Function],
  "getByPlaceholderText": [Function],
  "getByRole": [Function],
  "getByTestId": [Function],
  "getByText": [Function],
  "getByTitle": [Function],
  "queryAllByAltText": [Function],
  "queryAllByDisplayValue": [Function],
  "queryAllByLabelText": [Function],
  "queryAllByPlaceholderText": [Function],
  "queryAllByRole": [Function],
  "queryAllByTestId": [Function],
  "queryAllByText": [Function],
  "queryAllByTitle": [Function],
  "queryByAltText": [Function],
  "queryByDisplayValue": [Function],
  "queryByLabelText": [Function],
  "queryByPlaceholderText": [Function],
  "queryByRole": [Function],
  "queryByTestId": [Function],
  "queryByText": [Function],
  "queryByTitle": [Function],
  "rerender": [Function],
  "unmount": [Function],
}
`;
